import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=7ee6dc8f&scoped=true&"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=7ee6dc8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee6dc8f",
  null
  
)

export default component.exports